import axios from '../plugins/axiosPlugins'
import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;



/**
 * 活动首页头部的数据统计
 * @returns 
 */
export const HomePage = (): Promise<any> => {
    return axios.get(`${baseURL}/HomePage`);
}

/**
 * 活动首页banner图
 * @returns 
 */
export const CarouseImg = (params: any): Promise<any> => {
    return axios.get(`${baseURL}/CarouseImg`, {params});
}

/**
 * 首页活动中心
 * @returns 
 */
export const HomeOrganizeActivitiy = (params:any): Promise<any> => {
    return axios.get(`${baseURL}/OrganizeActivitiy/HomeOrganizeActivitiy`, {params});
}

/**
 * 找活动列表
 * @param params 
 * @returns 
 */
export const OrganizeActivitiy = (params:{name: string, pageNum: number, pageSize: number}): Promise<any> => {
    return axios.get(`${baseURL}/OrganizeActivitiy`, {params});
}

/**
 * 活动详情
 * @param params 
 * @returns 
 */
export const OrganizeActivitiyDetail = (params:string): Promise<any> => {
    return axios.get(`${baseURL}/OrganizeActivitiy/${params}`);
}

/**
 * 报名活动
 * @param data 
 * @returns 
 */
export const SignUpActivitiy = (data: any): Promise<any> => {
    return axios.post(`${baseURL}/OrganizeActivitiy/SignUpActivitiy`, data);
}

/**
 * 最近一个活动
 * @returns 
 */
export const GetLastTimeOrganizeActivitiy = (): Promise<any> => {
    return axios.get(`${baseURL}/OrganizeActivitiy/GetLastTimeOrganizeActivitiy`);
}

/**
 * 是否可以签到
 * @param params 
 * @returns 
 */
export const IsTimetoCheckIn = (params:any): Promise<any> => {
    return axios.get(`${baseURL}/OrganizeActivitiy/IsTimetoCheckIn`, {params});
}

/**
 * 签到活动 checkInType = 1（开始签到）,2 = (结束签到)
 * @param data 
 * @returns 
 */
export const CheckInActivitiy = (data:any): Promise<any> => {
    return axios.post(`${baseURL}/OrganizeActivitiy/CheckInActivitiy`, data);
}

/**
 * 我的报名活动数
 * @returns 
 */
export const MyPage = (): Promise<any> => {
    return axios.get(`${baseURL}/MyPage`);
}

/**
 * 已报名活动
 * @param params 
 * @returns 
 */
export const GetJoinInOrganizeActivitiy = (params:{name: string, pageNum: number, pageSize: number}): Promise<any> => {
    return axios.get(`${baseURL}/OrganizeActivitiy/GetJoinInOrganizeActivitiy`, {params});
}

/**
 * 已签到活动
 * @param params 
 * @returns 
 */
export const GetSignupOrganizeActivitiy = (params:{name: string, pageNum: number, pageSize: number}): Promise<any> => {
    return axios.get(`${baseURL}/OrganizeActivitiy/GetSignupOrganizeActivitiy`, {params});
}